import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";

import { SectionTitle, SectionSubTitle } from "src/library/components/exports";
// import Challenges from "./Challenges";
import Prizes from "./Prizes";
import CONTENT from "src/library/content.json";

export default function EventInformation() {
  const {
    challengesPrizes: {
      title,
      challengeSubTitle,
      prizeSubTitle,
      // challengeList,
      prizeList,
    },
  } = CONTENT;

  return (
    <Box
      sx={{
        pt: 2,
        pb: 6,
      }}
    >
      <Container maxWidth="md">
        <Grid container direction="column" justifyContent="center">
          <Grid item>
            <SectionTitle title={title} color="text.primary" />
          </Grid>
          <Grid item container justifyContent="center">
            <SectionSubTitle title={prizeSubTitle} color="text.secondary" />
          </Grid>
          <Grid item container>
            <Prizes prizeList={prizeList} />
          </Grid>
          <Grid item container justifyContent="center" sx={{ mt: 2 }}>
            <SectionSubTitle title={challengeSubTitle} color="text.secondary" />
          </Grid>
          {/* <Grid item container>
            <Challenges challengeList={challengeList} />
          </Grid> */}
        </Grid>
      </Container>
    </Box>
  );
}
